<div
  class="position-relative"
  style="bottom: 2px;"
  *ngIf="user && ['super_admin', 'sales_rep', 'sales_manager'].includes(user.role.name)"
  fxLayout="row"
>
  <div style="height: 40px">
    <mat-icon
      svgIcon="select_dashboard"
      class="icons-switch position-absolute"
      style="height: 20px !important;    margin-top: 3px;
margin-right: 7px;"
      fxShow.xs
      fxHide
    ></mat-icon>
    <div fxLayout="column" class="btns position-absolute">
      <div
        class="button-actions inactive-color"
        [class.open-btn]="selectorActive"
        fxLayout="row"
        fxLayoutAlign="space-around end"
        (click)="
          changeDashboard(getDashboardActive(1));
          selectorActive = false
        "
      >
        <span class="title1" [ngStyle.xs]="{ 'font-size': '14px' }">{{
          getDashboardActive(1, true)
        }}</span>
        <div
          (click)="$event.stopPropagation(); selectorActive = !selectorActive"
        >
          <mat-divider [vertical]="true"></mat-divider>
          <mat-icon *ngIf="!selectorActive">keyboard_arrow_up</mat-icon>
          <mat-icon *ngIf="selectorActive">keyboard_arrow_down</mat-icon>
        </div>
      </div>
      <div
        *ngIf="selectorActive"
        fxLayout="row"
        class="button-actions"
        (click)="
          changeDashboard(getDashboardActive(2));
          selectorActive = false
        "
        fxLayoutAlign="space-around end"
      >
        <div>
          <span class="title2" [ngStyle.xs]="{ 'font-size': '14px' }">{{
            getDashboardActive(2, true)
          }}</span>
        </div>
        <div>
          <mat-divider
            [vertical]="true"
            style="margin-left: 1px;"
          ></mat-divider>
          <mat-icon style="opacity : 0;">keyboard_arrow_down</mat-icon>
        </div>
      </div>
    </div>
  </div>
</div>
